import React from "react";
import AppLayout from "../components/AppLayout";
import CourseCard from "../components/CourseCard";
import { courses } from "../data/mockData";

export default function MyCourses() {
    const enrolled = courses.filter((c) => c.enrolled);

    return (
        <AppLayout searchPlaceholder="Search your courses...">
            <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
                <div>
                    <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight">My Courses</h1>
                    <p className="text-sm text-gray-400 mt-2">{enrolled.length} active course{enrolled.length !== 1 ? "s" : ""} • Keep going!</p>
                </div>
                <div className="flex gap-2">
                    {["All", "In progress", "Completed"].map((f, i) => (
                        <button
                            key={f}
                            data-testid={`filter-${f.toLowerCase().replace(" ", "-")}`}
                            className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
                                i === 0 ? "bg-ink-700 text-white border border-white/10" : "text-gray-400 hover:text-white border border-transparent"
                            }`}
                        >
                            {f}
                        </button>
                    ))}
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {enrolled.map((c) => (
                    <CourseCard key={c.id} course={c} showProgress />
                ))}
            </div>
        </AppLayout>
    );
}
